import {Avatar} from "material-ui";
import React, {useRef, useState} from "react";
import {Icon, Image, Input, Message, Popup, Segment} from "semantic-ui-react";
import {IReduxState} from "../redux/IReduxState";
import {IUserSettings} from "../data/IUserSettings";
import {MenuDto, UserDetailsDto} from "../services/Client";
import {selectBaseLinks, selectClient, selectUserDetails, selectUserSettings} from "../redux/selectors";
import {compose} from "redux";
import {withRouter} from "react-router";
import {translate} from "react-i18next";
import {connect} from "react-redux";
import {stringAvatar, stringToColor} from "../utils/GeneralUtils";
import HATEOASClient, {ChatbotDto} from "src/services/HATEOASClient";

const PROMTChatBot = ({userDetails, client, baseLinks}: IMapStateToProps) => {
    const messageRef = useRef<any>();
    const [isOpen, setIsOpen] = useState(false);
    const [messages, setMessages] = useState<any>([
        {text: "Hi I am ProMTChatCat, How may I help you", author: "bot", displayName: ""},
    ]);
    const [loading, setLoading] = useState(false);
    const [chatbotArea, setChatbotArea] = useState<ChatbotDto | undefined>(undefined);

    const handleUserMessage = async (message: any) => {
        try {
            setMessages((currentMessages: any) => [
                ...currentMessages,
                {text: message, author: 'user', displayName: userDetails ? userDetails.displayName : ''},
            ]);
            setLoading(true);
            if (!chatbotArea) {
                throw new Error('ChatCat area is not initialized');
            }

            const response = await client.POST_promtChatCat(chatbotArea).execute({message});
            setMessages((currentMessages: any) => [
                ...currentMessages,
                {
                    text: response.answer ? response.answer : "No answer received.",
                    author: "bot",
                    displayName: "",
                },
            ]);

            if (messageRef.current) {
                messageRef.current.scrollIntoView({
                    behavior: "smooth",
                    block: "end",
                    inline: "nearest",
                });
            }
        } catch (e) {
            setLoading(false);
            console.error("Error:", e);
            setMessages((currentMessages: any) => [
                ...currentMessages,
                {
                    text: "An error occurred while contacting ChatCat. Please try again.",
                    author: "bot",
                    displayName: "",
                },
            ]);
        } finally {
            setLoading(false);
        }
    };
    return (
        <Popup
            trigger={<Image className="chatbotImg" src="./images/chatcat.png" avatar={true} />}
            content={
                <Segment className="chatbot-popup-segment">
                    <Segment inverted={true} className="chatbot-header-segment">
                        <div className="logo-image">
                            <img src="./images/Logos/ProMT_Black_30.png" className="ui centered image" />
                        </div>
                    </Segment>
                    <div className="message_container">
                        {messages.map((message: any, index: number) => (
                            <div
                                key={index}
                                className={`chatbot-message-row ${message.author === "user" ? "is-user" : "is-bot"}`}
                                // @ts-ignore
                                ref={messageRef}
                            >
                                {message.displayName ? (
                                    <Avatar
                                        className="avatar_normal displayname"
                                        {...stringAvatar(message.displayName)}
                                    />
                                ) : (
                                    <Avatar
                                        className="avatar_normal"
                                        src={message.author === "user" ? "./images/user.png" : "./images/chatcat.png"}
                                    />
                                )}
                                <Message
                                    size="small"
                                    className="chatbot-message-card"
                                    content={message.text}
                                    floating={message.author === "user"}
                                />
                            </div>
                        ))}
                    </div>
                    <Input
                        fluid={true}
                        icon={
                            !loading ? (
                                <Icon name="search" size="large" />
                            ) : (
                                <Icon name="circle notched" loading={true} size="large" />
                            )
                        }
                        placeholder="Type a message..."
                        onKeyDown={(event: any) => {
                            if (event.key === "Enter") {
                                handleUserMessage(event.target.value);
                                event.target.value = "";
                            }
                        }}
                    />
                </Segment>
            }
            on="click"
            open={isOpen}
            onClose={() => setIsOpen(false)}
            onOpen={() => {
                setIsOpen(true);
                if (!chatbotArea) {
                    if (baseLinks) {
                        setLoading(true);
                        client
                            .GET_promtChatCatArea(baseLinks)
                            .execute()
                            .then((response: any) => {
                                if (response) {
                                    setChatbotArea(response);
                                }
                                setLoading(false);
                            });
                    }
                }
            }}
            position="top center"
        />
    );
};
interface IMapStateToProps {
    userSettings: IUserSettings;
    userDetails: UserDetailsDto | undefined;
    client: HATEOASClient;
    baseLinks: MenuDto | undefined;
}
const mapStateToProps = (state: IReduxState): IMapStateToProps => ({
    userSettings: selectUserSettings(state),
    userDetails: selectUserDetails(state),
    client: selectClient(state),
    baseLinks: selectBaseLinks(state),
});
interface IOwnProps {}

export default compose<React.ComponentType<IOwnProps>>(
    withRouter,
    connect<IMapStateToProps, any>(mapStateToProps, null)
)(PROMTChatBot);



// WEBPACK FOOTER //
// ./src/chatbot/PROMTChatBot.tsx